import { DropDown, Input } from '@finbeat/react-toolkit';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import GetOptions from 'utils/options';

type ReportDetailsFilterProps = {
    id: string | number;
    reportTypes: DropDown[];
    type?: string;
};

const ReportDetailsFilter = ({ reportTypes, type, id }: ReportDetailsFilterProps) => {
    useTranslation();
    return (
        <>
            <Row>
                <Col>
                    <Input id="rd-id" value={id} label={t('BackOfficeReportType')} disabled />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="rd-type"
                        value={type}
                        label={t('BackOfficeReportType')}
                        type="select"
                        loading={!reportTypes.length}
                        options={GetOptions(reportTypes, true, false)}
                        disabled
                    />
                </Col>
            </Row>
        </>
    );
};

export default ReportDetailsFilter;
